export default __webpack_public_path__ + "static/media/wallet.cd29a3ed.svg";